import {
	svc_getCategoryMenu,
	svc_deleteMenuItem,
	svc_cloneMenuItem,
	svc_getAllOutletsMenu,
	svc_getOutletMenu,
	svc_editMenuItemSoldOut
} from "@/services/menuitem";
import { svc_search, svc_fetchOne, svc_addOne, svc_editOne } from "@/services";
import { message } from "antd";
import "lodash";
import logger from "@/utils/logger";
import { showServerResponse } from "@/utils/message";
const apiPrefix = "menu_items";

const Model = {
	namespace: "m_MenuItem",
	state: {
		menu_items: [],
		menu_item: {},
		soldOutMenuItemList: [],
	},
	reducers: {
		handleFetch(state, { payload: { menu_items } }) {
			logger(`** MenuItem reducers response ${JSON.stringify(menu_items)}`, 5);
			return { ...state, menu_items };
		},
		fetchOneMenuItem(state, { payload: { menu_item } }) {
			logger(`** MenuItem reducers response ${JSON.stringify(menu_item)}`, 5);
			return { ...state, menu_item };
		},
		handleFetchSoldOutMenuItemList(state, { payload: { soldOutMenuItemList } }) {
			logger(`** MenuItem reducers response ${JSON.stringify(soldOutMenuItemList)}`, 5);
			return { ...state, soldOutMenuItemList };
		},
	},
	effects: {
		*fetchCategoryMenu({ searchKey, saveToState = true }, { call, put }) {
			let menu_items = yield call(svc_getCategoryMenu, searchKey);
			_.forEach(menu_items, function (row) {
				row.key = row.id;
			});

            if (saveToState) {
                yield put({
                    type: "handleFetch",
                    payload: { menu_items },
                });
            }

			return menu_items;
		},
		*fetchAllOutletsMenu({ searchKey }, { call, put }) {
			let menu_items = yield call(svc_getAllOutletsMenu, searchKey);
			_.forEach(menu_items, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetch",
				payload: { menu_items },
			});

			return menu_items;
		},
		*fetchOutletMenu({ searchKey }, { call, put }) {
			let menu_items = yield call(svc_getOutletMenu, searchKey);
			_.forEach(menu_items, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetch",
				payload: { menu_items },
			});

			return menu_items;
		},

		*fetchOutletMenuXREF({ payload }, { call, put }) {
			let menu_items = yield call(svc_getOutletMenu, { brand: payload.brand_id, outlet: payload.upos_outlet });
			_.forEach(menu_items, function (row) {
				row.key = row.id;
			});

			yield put({
				type: "handleFetch",
				payload: { menu_items },
			});

			return menu_items;
		},
		
		*fetchMenuItem({ searchKey }, { call, put }) {
			let menu_item = yield call(svc_fetchOne, apiPrefix, searchKey);

			yield put({
				type: "fetchOneMenuItem",
				payload: { menu_item },
			});

			return menu_item;
		},
		*addMenuItem({ payload }, { call, put }) {
			delete payload.id;
			if (payload.outlet == -1) {
				payload.outlet = null;
			}
            if (payload.code)
                payload.code = payload.code.toUpperCase()
            if (payload.accounting_category)
                payload.accounting_category = payload.accounting_category.toUpperCase()

			const response = yield call(svc_addOne, apiPrefix, payload);
			showServerResponse(response);

			return response;
		},
		*updateMenuItem({ payload }, { call, put }) {
			if (payload && payload.id) {
                if (payload.code)
                    payload.code = payload.code.toUpperCase()
                if (payload.accounting_category)
                    payload.accounting_category = payload.accounting_category.toUpperCase()
                
				const response = yield call(svc_editOne, apiPrefix, payload, "id");
				showServerResponse(response);
				return response;
			}
		},
		*deleteMenuItem({ payload }, { call, put }) {
			if (payload && payload.id) {
				const response = yield call(svc_deleteMenuItem, payload.id);
				showServerResponse(response);
				return response;
			}
		},
		*cloneMenuItem({ payload }, { call, put }) {
			if (payload && payload.id && payload.toCategoryId) {
				const response = yield call(svc_cloneMenuItem, payload.id, payload.toCategoryId);
				showServerResponse(response);
				return response;
			}
		},
		*reorderMenuItems({ payload }, { call, put }) {
			if (payload && payload.length > 0) {
				const response = yield call(svc_addOne, apiPrefix, payload, "custom/reorder");
				showServerResponse(response);
				return response;
			}
		},
		*fetchSoldOutMenuItemList({ payload }, { call, put }) {
			const queryObj = {
				...(payload.brand && { brand: payload.brand }),
				...(payload.outlet && payload.outlet > 0 && { outlet: payload.outlet }),
			};
			
			let soldOutMenuItemList = yield call(svc_search, `${apiPrefix}/sold_out_list`, queryObj);
			_.forEach(soldOutMenuItemList, function (row) {
				row.key = row.id;
			});
			
			yield put({
				type: "handleFetchSoldOutMenuItemList",
				payload: { soldOutMenuItemList },
			});
		},
		*updateMenuItemSoldOut({ payload }, { call, put }) {
			const { brandId, outletId, soldOut, formData } = payload;
			const response = yield call(svc_editMenuItemSoldOut, brandId, outletId, soldOut, formData);
			showServerResponse(response);
			return response;
		},

		*clearMenuItems({ }, { put }) {
			yield put({
				type: "handleFetch",
				payload: { menu_items: [] },
			});
		},
	},
	subscriptions: {},
};

export default Model;
